var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0.000000,128.000000) scale(0.100000,-0.100000)","stroke":"none"},[React.createElement("path",{"d":"M382 929 c-35 -13 -48 -53 -29 -83 22 -33 52 -41 82 -22 32 21 40 52\n21 80 -17 28 -43 36 -74 25z","key":0}),React.createElement("path",{"d":"M695 719 l-35 -31 0 26 c0 25 -2 26 -60 26 l-60 0 0 -195 0 -195 60\n0 60 0 0 115 c0 84 4 124 15 145 23 45 82 52 120 14 12 -12 15 -43 15 -145 l0\n-129 66 0 67 0 -5 143 c-4 118 -8 149 -26 183 -25 49 -71 74 -136 74 -36 0\n-52 -6 -81 -31z","key":1}),React.createElement("path",{"d":"M350 545 l0 -195 60 0 60 0 -2 193 -3 192 -57 3 -58 3 0 -196z","key":2})]));
}

Linkedin.defaultProps = {"version":"1.0","width":"128.000000pt","height":"128.000000pt","viewBox":"0 0 128.000000 128.000000","preserveAspectRatio":"xMidYMid meet"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
